import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/styles";
import React from "react";

// const RED_COLOR_RGB = [211, 47, 47]; // #D32F2F
const RED_COLOR_RGB = [209, 53, 20];
// const GREEN_COLOR_RGB = [67, 160, 71]; // #43A047
const GREEN_COLOR_RGB = [11, 154, 11]; // #43A047

const useStyles = makeStyles((theme) => ({
  slider: (props) => {
    let colorRatio =
      props.values.length > 0 ? props.value / (props.values.length - 1) : 1;
    let color = getColorFromScoreRatio(colorRatio);
    return {
      "& .MuiSlider-track": {
        backgroundColor: color,
      },
      "& .MuiSlider-thumb": {
        backgroundColor: color,
      },
    };
  },
}));

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function getRGBValuesFromScoreRatio(ratio) {
  if (ratio < 0) {
    return [128, 128, 128];
  }
  return RED_COLOR_RGB.map((num, idx) => {
    return Math.round(
      num + ratio * (GREEN_COLOR_RGB[idx] - RED_COLOR_RGB[idx])
    );
  });
}

export function getHexFromScoreRatio(ratio) {
  let rgbValues = getRGBValuesFromScoreRatio(ratio);
  return rgbToHex(rgbValues[0], rgbValues[1], rgbValues[2]);
}

export function getColorFromScoreRatio(ratio) {
  let rgbValues = getRGBValuesFromScoreRatio(ratio);
  return `rgb(${rgbValues.toString()})`;
}

export default function ScoringScaleSlider(props) {
  const classes = useStyles(props);
  return (
    <Slider
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      marks={props.values.map((value, index) => {
        return { label: value, value: index };
      })}
      valueLabelDisplay={props.values.length > 10 ? "auto" : "off"}
      min={0}
      max={props.values.length - 1}
      valueLabelFormat={(value) => props.values[value]}
      className={
        props.className
          ? `${props.className} ${classes.slider}`
          : classes.slider
      }
      name={props.name}
      disabled={props.disabled}
    />
  );
}
